import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from '@components/toolbar';
import { LoadingModule } from '@components/loading';
import { ButtonModule } from '@components/button';
import { InputModule } from '@components/inputs';
import { CsIconModule } from '@components/icon';
import { OrderFlowStepsComponent } from '@components/order-flow-steps/order-flow-steps.component';
import { CartProductCardComponent } from '@components/cart-product-card/cart-product-card.component';
import { CartFreeProductCardComponent } from '@components/cart-free-product-card/cart-free-product-card.component';
import { PopUpModule } from '@components/pop-up';
import { DiscontinuedPopupModule } from '@shared/discontinued-popup/discontinued-popup.module';
import { ProductCartComponent } from './cart.component';
import { AovBannerComponent } from './aov-banner/app-aov-banner.component';
import { DirectivesModule } from '@directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        ToolbarModule,
        LoadingModule,
        ButtonModule,
        InputModule,
        CsIconModule,
        PopUpModule,
        DiscontinuedPopupModule,
        AovBannerComponent,
        OrderFlowStepsComponent,
        CartProductCardComponent,
        CartFreeProductCardComponent,
        DirectivesModule,
    ],
  declarations: [ProductCartComponent],
  exports: [],
})
export class ProductCartModule {}
